"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = OpeningHours;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function OpeningHours(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "opening-hours"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,8.5A42.5,42.5,0,1,0,92.5,51,42.548,42.548,0,0,0,50,8.5Zm0,80A37.5,37.5,0,1,1,87.5,51,37.542,37.542,0,0,1,50,88.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,15.985a2.5,2.5,0,0,0-2.5,2.5V41a2.5,2.5,0,0,0,5,0V18.485A2.5,2.5,0,0,0,50,15.985Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M72.515,48.5H60a2.5,2.5,0,0,0,0,5H72.515a2.5,2.5,0,0,0,0-5Z"
  })))));
}